// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.bun/css-loader@7.1.4+018dfbff5b436835/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-class {
  width: 100%;
}

.rdw-editor-wrapper {
  margin: 1rem auto;
  padding: 5px;
}
.rdw-editor-wrapper > div {
  padding: 7.5px;
  padding-top: 10px;
}

.rdw-editor-main {
  padding-top: 5px;
  height: 150px !important;
  overflow-y: scroll;
}
.public-DraftStyleDefault-ltr {
  margin: 0;
}

.rdw-editor-wrapper > div {
  transition: border-color 50ms;
}
.rdw-dropdown-wrapper .rdw-dropdown-selectedtext span {
  position: absolute;
  top: 35%;
  transform: translateY(-35%);
}
.rdw-fontsize-dropdown {
  min-width: 50px;
}
.rdw-block-dropdown,
.rdw-fontfamily-dropdown {
  width: 150px;
}
.nativeSelect .options {
  background: red !important;
  font-weight: 900;
}
.myClass {
  width: 100%;
}
.options {
  background: red !important;
}

.resetDateButton {
  background: transparent;
  border: none;
  border-radius: 5px;
  transition: 0.35s;
}
.resetDateButton:hover {
  cursor: pointer;
  background: rgb(240, 240, 240);
}
.resetDateButton:focus {
  outline: none;
  animation: myAnimation 0.2s forwards;
}

@keyframes myAnimation {
  from {
    box-shadow: none;
  }
  to {
    box-shadow: 0px 3px 3px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 10px 2px rgba(0, 0, 0, 0.12);
  }
}

div.pac-container.pac-logo {
  z-index: 9999;
}

.AcceptDataPrivacy-feel {
  color: rgb(240, 240, 240);
}
`, "",{"version":3,"sources":["webpack://./../../../libs/html/components/build/assets/inputFields.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;;EAEE,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,2HAA2H;EAC7H;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".wrapper-class {\n  width: 100%;\n}\n\n.rdw-editor-wrapper {\n  margin: 1rem auto;\n  padding: 5px;\n}\n.rdw-editor-wrapper > div {\n  padding: 7.5px;\n  padding-top: 10px;\n}\n\n.rdw-editor-main {\n  padding-top: 5px;\n  height: 150px !important;\n  overflow-y: scroll;\n}\n.public-DraftStyleDefault-ltr {\n  margin: 0;\n}\n\n.rdw-editor-wrapper > div {\n  transition: border-color 50ms;\n}\n.rdw-dropdown-wrapper .rdw-dropdown-selectedtext span {\n  position: absolute;\n  top: 35%;\n  transform: translateY(-35%);\n}\n.rdw-fontsize-dropdown {\n  min-width: 50px;\n}\n.rdw-block-dropdown,\n.rdw-fontfamily-dropdown {\n  width: 150px;\n}\n.nativeSelect .options {\n  background: red !important;\n  font-weight: 900;\n}\n.myClass {\n  width: 100%;\n}\n.options {\n  background: red !important;\n}\n\n.resetDateButton {\n  background: transparent;\n  border: none;\n  border-radius: 5px;\n  transition: 0.35s;\n}\n.resetDateButton:hover {\n  cursor: pointer;\n  background: rgb(240, 240, 240);\n}\n.resetDateButton:focus {\n  outline: none;\n  animation: myAnimation 0.2s forwards;\n}\n\n@keyframes myAnimation {\n  from {\n    box-shadow: none;\n  }\n  to {\n    box-shadow: 0px 3px 3px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 10px 2px rgba(0, 0, 0, 0.12);\n  }\n}\n\ndiv.pac-container.pac-logo {\n  z-index: 9999;\n}\n\n.AcceptDataPrivacy-feel {\n  color: rgb(240, 240, 240);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
